import { SectionWithImagePageSchema } from 'cms/schemaTypes/staticPages/documents/sectionWithImage'

import { urlFor } from 'lib/sanity/image'
import { cssColors } from 'shared/ui/utils/cssTokens'

import MediaTextBlock from '../landings/MediaTextBlock'
import { SectionContainer } from '../landings/styles'

interface CooperationDetailsSectionsProps {
  forWhomSection: SectionWithImagePageSchema
  whatWeOfferSection: SectionWithImagePageSchema
  howWeWorkSection: SectionWithImagePageSchema
}

const CooperationDetailsSections = ({
  forWhomSection,
  whatWeOfferSection,
  howWeWorkSection
}: CooperationDetailsSectionsProps) => {
  const sections = [forWhomSection, whatWeOfferSection, howWeWorkSection]

  return (
    <>
      {sections.map((section, i) => {
        return (
          <SectionContainer
            $condensed
            key={section.header}
            $tablet={false}
            $mobile={false}
          >
            <MediaTextBlock
              header={section.header}
              content={section.content || []}
              imageSrc={urlFor(section.image.asset.asset).url()}
              imageAlt={section.image.alt}
              imageSide={i % 2 !== 0 ? 'left' : 'right'}
              srcIconList='/static/icons/check-circle.svg'
              color={
                i % 2 === 0
                  ? cssColors.brand.quaternary
                  : cssColors.background.base
              }
            />
          </SectionContainer>
        )
      })}
    </>
  )
}

export default CooperationDetailsSections
